import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const DofollowVsNofollowBacklinkRatio = ({ data }) => {
  // Initialize counters
  const stats = { dofollow: 0, nofollow: 0 };

  // Count dofollow and nofollow backlinks
  data.forEach(item => {
    const backlinks = parseInt(item.backlinks.replace(/,/g, ''), 10); // Convert backlinks to number
    const dofollow = parseInt(item.dofollow.replace(/,/g, ''), 10);   // Convert dofollow to number

    // Calculate nofollow as the difference between total backlinks and dofollow
    const nofollow = backlinks - dofollow;

    // Update the stats
    stats.dofollow += dofollow;
    stats.nofollow += nofollow;
  });

  // Prepare data for the chart
  const chartData = [
    { name: 'Dofollow', value: stats.dofollow },
    { name: 'Nofollow', value: stats.nofollow }
  ];

  const COLORS = ['var(--bl-color)', '#ce173c'];

  return (
    <PieChart width={400} height={160}>
      <Pie
        data={chartData}
        cx="50%"
        cy="50%"
        labelLine={false}
        outerRadius={60}
        fill="#8884d8"
        dataKey="value"
      >
        {chartData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index]} />
        ))}
      </Pie>
      <Tooltip />
      <Legend />
    </PieChart>
  );
};

export default DofollowVsNofollowBacklinkRatio;
